import React from 'react';
import { translate } from 'react-polyglot';
import Link from '../Link';
import { links } from '../../lib/constants';
import './DisclaimerBox.scss';

const DisclaimerBox = ({ t, licenseTypeImage, licenseTypeMessage }) => {
    return (
        <div className="disclaimer-container">
            <p className="disclaimerLink">
                <span>{t('Book.contentFooterDescriptionDisclaimer')}</span>
                <Link
                    className="LicenceDiscriptionLink"
                    href={links.termsOfUse()}
                >
                    {' '}
                    {/* {'https://literacycloud.org/terms-and-conditions'} */}
                    {t('global.terms-and-conditions')}
                </Link>
            </p>
            {licenseTypeImage && (
                <p className="bookLicenseContainer">
                    <img
                        className="bookLicense"
                        src={licenseTypeImage}
                        alt="license"
                    />
                </p>
            )}
            {licenseTypeMessage && (
                <p className="licenseDescription">{licenseTypeMessage}</p>
            )}
        </div>
    );
};

export default translate()(DisclaimerBox);
